import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
    children: ReactNode;
    contentClassName?: string;
    id?: string;
}

const ScrollableTabPanel = ({ children, contentClassName, id }: Props) => (
    <div
        id={id}
        className={twMerge(
            'scrollbar scrollbar-gutter-stable flex min-h-0 flex-1 justify-center overflow-y-auto',
            contentClassName,
        )}
    >
        <div className="w-full max-w-[600px]">{children}</div>
    </div>
);

export default ScrollableTabPanel;
